import { FullCalendar } from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import interactionPlugin from "@fullcalendar/interaction";
import api from "../../services/service_calendar";
import apiMarim from "../../services/service_undefined_v2";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    FullCalendar
  },
  data () {
    return {
      hourSelected: "1",
      keypage: 0,
      nowDate: moment(new Date()).add(1 ,'day'),
      hourList: [1, 3, 5, 7, 15, 30],
      defaultValue: moment('00:00:00', 'HH:mm:ss'),
      description: "",
      messageDescription: "",
      view_mode: 0,
      date_select: "",
      modal_day: [],
      now_month: "",
      activity_status :{
        waiting: 0,
        late: 3,
        success: 1
      },
      branch: {
        id: 0
      },
      data_modal: {
        id: 0,
        title: "",
        start: moment(new Date(), "DD/MM/YYYY HH:mm"),
        color: "White",
        all_day: false
      },
      result_data: [],
      result_data_furture: [],
      result_data_now: [],
      result_data_past: [],
      result_detail: {
        id: 0,
        title: "",
        start: moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
        activityDate: '',
        documentDate: '',
        color: "White",
        status: 0,
        description: "",
        messageDescription: "",
        all_day: false
      },
      events: [],
      pageData: {},
      config: {
        defaultView: "month",
        locale: "th",
        selectable: false,
        weekends: true,
        plugins: [interactionPlugin],
        header: {
          right: ""
        },
        contentHeight: "auto"
      },
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),

      hour_list: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      minute_list: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      second_list: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59"
      ],
      s_h: "00",
      e_h: "23",
      s_m: "00",
      e_m: "59",
      s_s: "00",
      e_s: "59",
      start_time: "000001",
      end_time: "235959"
    };
  },
  methods: {
    getEventMonth (view) {
      this.$store.commit("Loading");
      this.now_month = this.convertTitleCalendar(view.title).split("-");
      this.getData();
    },
    callback (key) {
      // console.log(key);
      let pageKey = parseInt(key) - 1;
      this.keypage = pageKey
      // console.log(this.result_data);
      this.result_data.sort((a,b) => parseInt(a.branch_code) - parseInt(b.branch_code))
      this.result_data_now = [];
      this.result_data_past = [];
      this.result_data_furture = [];
      for(let datas of this.result_data[pageKey].calendar)
      {
        if(new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() > new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
          this.result_data_furture.push(datas)
        } else if (new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() === new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
          this.result_data_now.push(datas)
        } else {
          this.result_data_past.push(datas)
        }
      }
      console.log(this.pageData)
      this.result_data_furture.sort((a,b) => new Date(b.start) - new Date(a.start))
      this.result_data_now.sort((a,b) => new Date(b.start) - new Date(a.start))
      this.result_data_past.sort((a,b) => new Date(b.start) - new Date(a.start))

      const actionOrder = {
        [this.activity_status.waiting]: 0,
        [this.activity_status.late]: 2,
        [this.activity_status.success]: 3
      };

      this.result_data_furture.sort((a, b) => {
        return (
          actionOrder[a.status] -
          actionOrder[b.status]
        );
      });

      this.result_data_now.sort((a, b) => {
        return (
          actionOrder[a.status] -
          actionOrder[b.status]
        );
      });

      this.result_data_past.sort((a, b) => {
        return (
          actionOrder[a.status] -
          actionOrder[b.status]
        );
      });


      this.pageData = this.result_data[pageKey];
      this.events = this.result_data[pageKey].calendar;
    },
    // getData () {
    //   if (this.branch !== 0) {
    //     let obj = {
    //       get_year: parseInt(this.now_month[1]),
    //       get_month: parseInt(this.now_month[0]),
    //       get_day: 0
    //     }
    //     api.list(
    //       this.branch.dyn_address + '/',
    //       {
    //         headers: {
    //           'Access-Token': this.branch.access_token
    //         }
    //       },
    //       obj,
    //       result => {
    //         if (result.response === 'success') {
    //           this.events = result.data
    //         } else {
    //           this.events = []
    //           this.alert_msg('warning', 'ดึงข้อมูลปฎิทิน', result.message)
    //         }
    //         this.$store.state.isLoading = false
    //       },
    //       error => {
    //         this.events = []
    //         this.alert_msg('error', 'ดึงข้อมูลปฎิทิน', 'เชื่อมต่อข้อมูลสาขาไม่ได้')
    //         console.log('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //         this.$store.state.isLoading = false
    //       }
    //     )
    //   }
    // },
    getData () {
      api.listByDate(
        sessionStorage.Url,
        {
          headers: {
            "Access-Token": sessionStorage.token
          }
        },
        {
          id: this.branch.id,
          company_id: 1,
          branch_id: 1,
          begin_date: this.dateDMY(this.startDate) + " " + "000001",
          end_date: this.dateDMY(this.endDate) + " " + this.end_time
        },
        result => {
          if (result.response === "success") {
            this.config = {
              defaultView: "month",
              locale: "th",
              selectable: false,
              weekends: true,
              plugins: [interactionPlugin],
              header: {
                right: ""
              },
              contentHeight: "auto"
            }
            this.result_data = result.data;
            this.result_data.sort((a,b) => parseInt(a.branch_code) - parseInt(b.branch_code))
            this.pageData = result.data[this.keypage];
            this.events = result.data[this.keypage].calendar;
            this.result_data_now = [];
            this.result_data_past = [];
            this.result_data_furture = [];
            for(let datas of this.result_data[this.keypage].calendar)
            {
              if(new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() > new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
                this.result_data_furture.push(datas)
              } else if (new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() === new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
                this.result_data_now.push(datas)
              } else {
                this.result_data_past.push(datas)
              }
            }
            this.result_data_furture.sort((a,b) => new Date(b.start) - new Date(a.start))
            this.result_data_now.sort((a,b) => new Date(b.start) - new Date(a.start))
            this.result_data_past.sort((a,b) => new Date(b.start) - new Date(a.start))

            const actionOrder = {
              [this.activity_status.waiting]: 0,
              [this.activity_status.late]: 2,
              [this.activity_status.success]: 3
            };

            this.result_data_furture.sort((a, b) => {
              return (
                actionOrder[a.status] -
                actionOrder[b.status]
              );
            });

            this.result_data_now.sort((a, b) => {
              return (
                actionOrder[a.status] -
                actionOrder[b.status]
              );
            });

            this.result_data_past.sort((a, b) => {
              return (
                actionOrder[a.status] -
                actionOrder[b.status]
              );
            });

          } else {
            this.events = [];
            this.alert_msg("warning", "ดึงข้อมูลปฎิทิน", result.message);
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.events = [];
          this.alert_msg(
            "error",
            "ดึงข้อมูลปฎิทิน",
            "เชื่อมต่อข้อมูลสาขาไม่ได้"
          );
          console.log("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.state.isLoading = false;
        }
      );
    },
    addData () {
      if (this.data_modal.title !== "") {
        // eslint-disable-next-line no-undef
        $("#calendarForm").modal("hide");
        this.$store.commit("Loading");
        const obj = {
          id: this.data_modal.id,
          title: this.data_modal.title,
          start: moment(this.data_modal.start).format("YYYY-MM-DD HH:mm:ss"),
          color: this.data_modal.color,
          all_day: false
        };
        if (obj.id === 0) {
          obj.status = 0;
        } else {
          obj.status = 1;
        }
        this.data_modal = {
          id: 0,
          title: "",
          start: moment(new Date(), "DD/MM/YYYY HH:mm"),
          color: "White",
          all_day: false
        };
        api.new(
          this.branch.dyn_address + "/",
          {
            headers: {
              "Access-Token": this.branch.access_token
            }
          },
          obj,
          result => {
            if (result.response === "success") {
              this.getData();
              this.alert_msg(
                "success",
                "ข้อมูลการนัดหมาย",
                "จัดการข้อมูลการนัดหมายสำเร็จ!!"
              );
            } else {
              this.alert_msg("warning", "จัดการข้อมูลปฎิทิน", result.message);
            }
          },
          error => {
            console.log(obj.id);
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
          }
        );
      } else {
        this.data_modal = {
          id: 0,
          title: "",
          start: moment(new Date(), "DD/MM/YYYY HH:mm"),
          color: "White",
          all_day: false
        };
        this.alert_msg("warning", "เพิ่มข้อมูลปฎิทิน", "ไม่มีข้อมูล");
        // eslint-disable-next-line no-undef
        $("#calendarForm").modal("hide");
      }
    },
    editModal (event) {
      event.start = moment(event.start, "DD/MM/YYYY HH:mm");
      this.data_modal = event;
      // eslint-disable-next-line no-undef
      $("#calendarForm").modal("show");
    },
    AllDay (event) {
      console.log("AllDay", event)
      this.$store.commit("Loading");
      this.date_select = this.dateFormatDMY(event);
      const d = this.date_select.split("/");
      let obj = {
        get_year: parseInt(d[2]),
        get_month: parseInt(d[1]),
        get_day: parseInt(d[0])
      };
      api.list(
        this.branch.dyn_address + "/",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        obj,
        result => {
          console.log(result)
          if (result.response === "success") {
            this.modal_day = result.data;
            if (this.modal_day.length > 0) {
              // eslint-disable-next-line no-undef
              $("#calendarAllDay").modal("show");
            }
          } else {
            this.alert_msg("warning", "ดึงข้อมูลปฎิทิน", result.message);
          }
          this.$store.commit("Loading");
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.commit("Loading");
        }
      );
    },
    dateFormatDMYHM (date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    delData (data) {
      Swal.fire({
        title: "ลบข้อมูลการนัดหมาย",
        text: "ท่านต้องการลบข้อมูลการนัดหมายนี้ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$store.commit("Loading");
          // eslint-disable-next-line no-undef
          $("#calendarAllDay").modal("hide");
          const obj = {
            id: data.id,
            title: data.title,
            start: moment(data.start).format("YYYY-MM-DD HH:mm:ss"),
            color: data.color,
            all_day: false,
            statue: 2
          };
          api.new(
            this.branch.dyn_address + "/",
            {
              headers: {
                "Access-Token": this.branch.access_token
              }
            },
            obj,
            result => {
              if (result.response === "success") {
                this.getData();
                this.alert_msg(
                  "success",
                  "ลบการนัดหมาย",
                  "ลบข้อมูลการนัดหมายสำเร็จ!!"
                );
              } else {
                this.alert_msg("warning", "ลบข้อมูลปฎิทิน", result.message);
              }
            },
            error => {
              console.log(obj.id);
              alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
              this.$store.commit("Loading");
            }
          );
        }
      });
    },
    dropUpdate (event) {
      event.start = moment(event.start, "DD/MM/YYYY HH:mm");
      this.data_modal = event;
      this.addData();
    },
    setStartTime () {
      this.start_time = this.s_h + this.s_m + this.s_s;
    },
    setEndTime () {
      this.end_time = this.e_h + this.e_m + this.e_s;
    },
    toggle () {
      // eslint-disable-next-line no-undef
      $('button[name="hourBtn"]')
        .toggleClass("active")
        .siblings()
        .not(this)
        .removeClass("active");
    },
    selectHour ($event) {
      this.nowDate = moment(new Date()).add($event.target.value, "day");
    },
    changeActivity (data) {
      this.result_detail = data;
      this.result_detail.activityDate = moment(data.start).format("DD/MM/YYYY HH:mm:ss");
      this.result_detail.documentDate = moment(data.create_time).format("DD/MM/YYYY HH:mm:ss");
      this.description = ''
      this.messageDescription = ''
      // eslint-disable-next-line no-undef
      $("#changeActivity").modal("show");
    },
    confirmActivity (data) {

      this.result_detail = data;
      this.result_detail.activityDate = moment(data.start).format("DD/MM/YYYY HH:mm:ss");
      this.result_detail.documentDate = moment(data.create_time).format("DD/MM/YYYY HH:mm:ss");
      this.description = ''
      this.messageDescription = ''
      // eslint-disable-next-line no-undef
      $("#confirmActivity").modal("show");
    },
    selectDateStart (current) {
      // console.log(current)
      return current && current.valueOf() <= moment(new Date()).add(-1,'day');
    },
    removeHowver () {
      // eslint-disable-next-line no-undef
      $('button[name="hourBtn"]')
        .toggleClass("active")
        .siblings()
        .not(this)
        .removeClass("active");
    },
    saveChangeActivity () {
      this.result_detail['description'] = this.description;
      this.result_detail['messageDescription'] = this.messageDescription;
      this.result_detail['branch_code'] = this.pageData.branch_code;
      this.result_detail['change_date'] = moment(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss')
      this.$store.commit("Loading");
      apiMarim.changeActivity(
      {
        data: this.result_detail
      },
      this.header,
      results => {
          if(results.data.status)
          {

            this.view_mode = 1
            this.getData();
            // this.$store.commit("Loading");
            // eslint-disable-next-line no-undef
            $("#changeActivity").modal("hide");
            this.$notification["success"]({
              message: "แจ้งเตือน",
              description: "เลื่อนเวลาการนัดหมายสำเร็จ"
            });
          } else {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "แจ้งเตือน",
              description: "เลื่อนเวลาการนัดหมายไม่สำเร็จ"
            });
          }
      },
        errors => {
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "เลื่อนเวลาการนัดหมายไม่สำเร็จ",
            description: errors.data.message
          });
        }
      );
    },
    saveConfirmActivity () {
      this.result_detail['description'] = this.description;
      this.result_detail['messageDescription'] = this.messageDescription;
      this.result_detail['branch_code'] = this.pageData.branch_code;
      this.result_detail['change_date'] = moment(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss')
      this.$store.commit("Loading");
      apiMarim.confirmActivity(
      {
        data: this.result_detail
      },
      this.header,
      results => {
          if(results.data.status)
          {
            this.view_mode = 1
            this.getData();
            // this.$store.commit("Loading");
            // eslint-disable-next-line no-undef
            $("#confirmActivity").modal("hide");
            this.$notification["success"]({
              message: "แจ้งเตือน",
              description: "จัดการนัดหมายสำเร็จ"
            });
          } else {
            this.$store.commit("Loading");
            this.$notification["warning"]({
              message: "แจ้งเตือน",
              description: "จัดการนัดหมายไม่สำเร็จ"
            });
          }
      },
        errors => {
          this.$store.commit("Loading");
          this.$notification["warning"]({
            message: "จัดการนัดหมายไม่สำเร็จ",
            description: errors.data.message
          });
        }
      );
    },
    detailActivity (data) {
      this.result_detail = data;
      this.result_detail.activityDate = moment(data.start).format("DD/MM/YYYY HH:mm:ss");
      this.result_detail.documentDate = moment(data.create_time).format("DD/MM/YYYY HH:mm:ss");
      // eslint-disable-next-line no-undef
      $("#detailActivity").modal("show");
    }
  },
  mounted () {
    this.checkUser();
    this.getBranch();
    this.setStartTime();
    this.setEndTime();
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0];
      this.getData();
    }, 500);
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/calendar.js